import { render, staticRenderFns } from "./StudentFormSummit.vue?vue&type=template&id=9a9f1184&scoped=true&"
import script from "./StudentFormSummit.vue?vue&type=script&lang=js&"
export * from "./StudentFormSummit.vue?vue&type=script&lang=js&"
import style0 from "./StudentFormSummit.vue?vue&type=style&index=0&id=9a9f1184&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a9f1184",
  null
  
)

export default component.exports